import * as React from 'react'; // tslint:disable-line
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { DefaultImage, ImageComponent } from '@shapeable/web';

// -------- Types -------->

export const Image: ImageComponent = (props) => {
  const { className, image, alt } = props;

  if (!image) {
    return null;
  }

  // check if there is a gatsby image available in the image data.
  const hasStatic = !!image.static;

  const isGif = image.type === 'image/gif';

  const staticImage = hasStatic && getImage(image.static);

  return hasStatic && !isGif ?
    <GatsbyImage className={className} image={staticImage} alt={alt || ''} /> :
    <DefaultImage {...props} />
};